import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgUser24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "User",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M20.735 17.62c-1.59-1.715-4.53-2.585-8.739-2.585-4.208 0-7.148.87-8.739 2.585-.635.685-1.365 1.854-1.244 3.575a.747.747 0 0 0 1.221.605c.192-.155.293-.479.274-.725a3.1 3.1 0 0 1 .85-2.436c1.276-1.377 3.917-2.104 7.638-2.104s6.362.728 7.64 2.104a3.1 3.1 0 0 1 .848 2.436c-.019.246.083.57.274.725a.75.75 0 0 0 1.055-.112.74.74 0 0 0 .166-.5c.13-1.701-.606-2.879-1.244-3.568M11.996 13.18a4.627 4.627 0 0 0 4.622-4.622V6.622A4.627 4.627 0 0 0 11.996 2a4.627 4.627 0 0 0-4.622 4.622v1.936a4.627 4.627 0 0 0 4.622 4.622M8.874 6.622c0-1.722 1.4-3.122 3.122-3.122s3.122 1.4 3.122 3.122v1.936c0 1.722-1.4 3.122-3.122 3.122a3.125 3.125 0 0 1-3.122-3.122z"
}));

export { SvgUser24 as default };
//# sourceMappingURL=User24.js.map
